module.exports = __webpack_public_path__ + "img/piece-of-shit-dash.cfcc2403.png";